/**
 * Return truncated string if length more than max
 * Can be used to set max value length for numeric fields
 * fieldProps={{ parse: value => maxLengthParser(value.toString(), 5) }}
 * @param limit
 * @param value
 */
export const maxLengthParser = (value: string, limit: number) => value.slice(0, limit);
export const getMaxLengthParser = (limit: number) => (value: string) => maxLengthParser(value, limit);
export const onlyNumbersParser = (value: string) => value.replace(/\D/g, '');
